<template>
  <div class="card is-w-60v">
    <header class="bandeau-modal card-header">
    </header>
    <div class="card-content">
      <section class="has-text-centered">
        <div class="mgb-50px">
        <h1 class="title is-size-3 has-text-centered">
          {{ $t('piecesJointes.modal.title') }}
        </h1>
        </div>
        <uploader ref="upload" class="mgt-30px pd-20pxupload-box" multiple
                  @added="fileAdded" @removed="fileRemoved"
                  @filePrevented="filePrevented"
                  :size="piecesJointesConfiguration.maxSize || taillePjLimite">
          <div class="columns">
            <div class="column">
              <b-icon
                  icon="file-multiple"
                  size="is-large"
                  type="is-primary">
              </b-icon>
            </div>
          </div>
          <div class="columns">
            <div class="column is-12 is-paddingless is-size-6 has-text-weight-bold">
              <h1 class=" is-size-4 has-text-weight-bold">
                {{ $t('piecesJointes.modal.addYourAttachments') }}
              </h1>
            </div>
          </div>
          <div class="columns">
            <div class="column is-12 is-paddingless  is-size-6">
              {{ $t('piecesJointes.modal.formatAndMaxSize') }}
            </div>
          </div>

        </uploader>
        <table v-if="errorFiles.length" class="table mgt-20px is-fullwidth">
          <tbody>
          <tr v-for="file in errorFiles" :key="file.id">
            <td>{{file.name}}</td>
            <td class="has-text-danger">
              {{file.errorMessage}}
            </td>
          </tr>
          </tbody>
        </table>
        <table v-if="files.length" class="table mgt-20px is-fullwidth">
          <thead>
          <tr>
            <th>{{ $t('piecesJointes.modal.fileName') }}</th>
            <th>{{ $t('piecesJointes.modal.type') }}</th>
            <th>{{ $t('piecesJointes.modal.description') }}</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="file in files" :key="file.id">
            <td>{{file.name}}</td>
            <td class="width-250">
              <b-field v-bind="isAfficheMessageInfo(file.groupType)">
                <b-select
                  v-model="file.groupType"
                  :placeholder="$t('piecesJointes.modal.selectType')"
                  expanded>
                  <option :value="null"></option>
                  <option
                    v-for="type in typesPiecesJointes"
                    :value="type.id"
                    :key="type.id">
                  {{ type.libelle }}
                  </option>
                </b-select>
              </b-field>
            </td>
            <td>
              <b-input v-model="file.description"></b-input>
            </td>
            <td>
              <b-icon
                  @click.native="$refs.upload.remove(file)"
                  class="is-cursor-pointer"
                  icon="delete"
                  type="is-danger">
              </b-icon>
            </td>
          </tr>
          </tbody>
        </table>
      </section>
      <br>
      <footer>
        <div class="has-text-centered">
          <button
              class="button btn-modal-annuler is-cancel has-text-centered button-modal"
              @click="$parent.close()">
            {{ $t('piecesJointes.modal.cancel') }}
          </button>
          <button class="button is-addOrEdit has-text-centered button-modal"
                  @click="ajouter" :disabled="!files.length">
            {{ $t('piecesJointes.modal.add') }}
          </button>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import * as types from '@/store/modules/attachments-mutation-type';
import { TAILLE_PJ_LIMITE } from '@/configuration/piecesJointes';
import messageSucces from '@/services/general/messageSucces';
import messageErreur from '@/services/general/messageErreur';
import Uploader from './uploader';

const Attachments = createNamespacedHelpers('attachments');

export default {
  name: 'ajout-piece-jointe',
  props: {
    autoSave: {
      type: Boolean,
    },
  },
  data() {
    return {
      files: [],
      errorFiles: [],
      types: [{ id: 1, label: 'Divers' }],
      taillePjLimite: TAILLE_PJ_LIMITE,
    };
  },
  computed: {
    ...Attachments.mapGetters({
      piecesJointesConfiguration: 'configuration',
      typesPiecesJointes: 'typesPiecesJointes',
    }),
  },
  components: { Uploader },
  methods: {
    ...Attachments.mapMutations({
      addAttachments: types.ADD_PIECE_JOINTE,
    }),
    ...Attachments.mapActions({
      loadAttachments: 'loadAttachments',
      updateAttachments: 'update',
    }),
    async ajouter() {
      const files = this.files.map(f => ({
        size: f.size,
        description: f.description,
        typeId: f.groupType,
        nom: f.name,
        thumb: f.thumb,
        file: f.file,
        compressedFile: f.compressedFile,
      }));
      this.addAttachments(files);
      if (this.autoSave) {
        const loadingComponent = this.$buefy.loading.open();
        try {
          await this.updateAttachments();
          await this.loadAttachments(); // TODO à améliorer avec le back
          const messageToast = this.$i18n.t('piecesJointes.messages.insertSuccess');
          loadingComponent.close();
          messageSucces(messageToast);
        } catch (e) {
          loadingComponent.close();
          messageErreur(this.$i18n);
        }
      }
      this.$emit('filesAjouter');
      this.$parent.close();
    },
    fileAdded(file) {
      this.files.push(file);
    },
    fileRemoved(file) {
      this.files = this.files.filter(x => x && x.id !== file.id);
    },
    filePrevented(error) {
      error.file.errorMessage = error.message;
      this.errorFiles.push(error.file);
    },
    isAfficheMessageInfo(groupType) {
      const findType = this.typesPiecesJointes.find(type => type.id === groupType);
      const result = findType?.pieceSupprimable ?? true;
      return {
        message: !result ? this.$t('piecesJointes.modal.infoTypePj') : '',
        type: !result ? 'is-warning' : '',
      };
    },
  },
};
</script>
